import { useCallback, useMemo, useRef } from 'react';

type Handler = (event: MouseEvent) => void;

export function useOnClickOutside(element: HTMLElement | null, handler: Handler) {
  const currentListener = useRef<any>();
  const listener = useCallback(
    (event: MouseEvent) => {
      if (element) {
        const rect = element.getBoundingClientRect();

        if (
          rect.left > event.clientX ||
          rect.right < event.clientX ||
          rect.top > event.clientY ||
          rect.bottom < event.clientY
        )
          handler(event);
      }
    },
    [element, handler],
  );

  useMemo(() => {
    window.removeEventListener('click', currentListener.current);
    window.addEventListener('click', listener);
    currentListener.current = listener;
  }, [listener]);
}

export default useOnClickOutside;
